import Axios from 'axios';
import {urlAPIDirectus} from "../config/Globals";

function findAllInRubrique(rubriqueId){
    return Axios
        .get(urlAPIDirectus+"ArticleLutte?filter[status][_eq]=published&fields=*&filter[pilier_lutte][_eq]="+rubriqueId)
        .then(response => response.data.data);
}

function search(search){
    return Axios
        .get(urlAPIDirectus+"ArticleLutte?filter[status][_eq]=published&filter[_or][0][titre][_icontains]="+search+"&filter[_or][1][contenu][_icontains]="+search+'&fields=*.*')
        .then(response => response.data.data);
}

export default {
    findAllInRubrique, search
}